import script from "./tour.vue?vue&type=script&setup=true&lang=js"
export * from "./tour.vue?vue&type=script&setup=true&lang=js"

import "./tour.vue?vue&type=style&index=0&id=366a3581&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366a3581"]])

export default __exports__